import { ThemeToggle } from "../components/ThemeToggle";

/** Shown when /auth/status reports jwt_configured=false. Auth is mandatory
 * in this build, so without JWT_SECRET nothing else can render — we
 * surface the fix instead of silently 500'ing or spinning. */
export function AuthDisabledPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-page px-4">
      <div className="absolute right-4 top-4">
        <ThemeToggle compact />
      </div>

      <div className="w-full max-w-lg rounded-xl border border-warn/40 bg-warn/10 p-7">
        <h1 className="font-mono text-xl font-bold text-warn">
          Auth is not configured
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-fg">
          The FX-Dash backend is up but has no{" "}
          <code className="rounded bg-surface px-1 py-0.5 font-mono text-warn">
            JWT_SECRET
          </code>{" "}
          set, so login can&apos;t work yet. The portal blocks access until the
          server can issue signed tokens.
        </p>

        <div className="mt-5 rounded-lg border border-border bg-surface p-4 text-xs">
          <p className="mb-3 text-[11px] font-medium uppercase tracking-wider text-fg-muted">
            How to fix
          </p>
          <ol className="list-decimal space-y-2 pl-5 text-fg">
            <li>
              Generate a long random secret locally:
              <pre className="mt-1.5 rounded-md bg-page px-3 py-2 font-mono text-[11px] text-success">
                python -c &quot;import secrets; print(secrets.token_urlsafe(64))&quot;
              </pre>
            </li>
            <li>
              Set{" "}
              <code className="rounded bg-page px-1 py-0.5 font-mono text-primary">
                JWT_SECRET
              </code>{" "}
              in the server&apos;s env (e.g. Coolify resource → Environment
              Variables → mark as secret).
            </li>
            <li>
              Redeploy. Reload this page; you&apos;ll land on the setup form.
            </li>
          </ol>
        </div>

        <p className="mt-4 text-[10px] uppercase tracking-wider text-fg-muted">
          this page is reachable to anyone — exposes no data
        </p>
      </div>
    </div>
  );
}
